define([
  'okta/underscore',
  'shared/util/TemplateUtil',
  'shared/views/BaseView',
  'qtip'
],
function (_, TemplateUtil, BaseView) {

  /**
   * @class InputLabel
   * @extends {Okta.View}
   * @private
   * The input's label.
   */
  return BaseView.extend({

    className: 'okta-form-label o-form-label',

    attributes: {
      'data-se': 'o-form-label'
    },

    /**
     * @constructor
     * @param  {Object} options options hash
     * @param  {String} [options.type] Input type
     * @param  {String|Function} [options.label] Label text
     * @param  {String|Function} [options.sublabel] Sub label text
     * @param  {String|Function} [options.tooltip] Tooltip text
     * @param  {String|Function} [options.inputId] Id of the inputs
     * @param  {String|Function} [options.id] Id of the inputs
     */
    constructor: function (options) {
      /* eslint max-statements: [2, 16] complexity: [2, 7]*/
      _.defaults(options, {inputId: options.id});
      delete options.id;

      BaseView.apply(this, arguments);

      var template;
      if (this._isLabelView(options.label)) {
        template = '<label for="{{inputId}}"></label>';
      } else if (_.contains(['radio', 'checkbox'], options.type) || !options.label) {
        template = '{{label}}';
      } else {
        //space added in the end of the label to avoid selecting label text with double click in read mode
        template = '<label for="{{inputId}}">{{label}}&nbsp;</label>';
      }
      if (options.sublabel) {
        template += '<span class="o-form-explain">{{sublabel}}</span>';
      }
      if (options.tooltip) {
        if (_.isString(options.tooltip)) {
          options.tooltip = {
            text: options.tooltip
          };
        }
        template += '<span class="o-form-tooltip icon-16 icon-only form-help-16" title="{{tooltip.text}}"></span>';
      }
      this.template = TemplateUtil.tpl(template);

    },

    getTemplateData: function () {
      var options = {label: ''};
      _.each(['inputId', 'label', 'sublabel', 'tooltip'], function (option) {
        options[option] = _.resultCtx(this.options, option, this);
      }, this);

      return options;
    },

    _isLabelView: function (label) {
      return !_.isUndefined(label) && label instanceof BaseView;
    },

    postRender: function () {
      var options = this.getTemplateData();
      if (this._isLabelView(options.label)) {
        this.removeChildren();
        this.add(options.label, 'label');
      }

      if (options.tooltip) {
        this.$('.o-form-tooltip').qtip(_.extend({
          style: {classes: 'qtip-custom qtip-shadow'},
          position: {
            my: 'bottom left',
            at: 'top center'
          },
          hide: {fixed: true},
          show: {delay: 0}
        }, options.tooltip.options));
      }
    }
  });

});



/** WEBPACK FOOTER **
 ** ./target/js/shared/views/forms/helpers/InputLabel.js
 **/